import "core-js/modules/es6.object.freeze";
// The app's theme (glass, src/themes/) and the looks' tokens (src/css/tokens/).
import Vue from 'vue';
import 'src/themes/themes.css';
import 'src/themes/themes-quasar.css'; // the design standard's tokens (#182): the type scale, the owner side's look (Atlas, the class at-look) and the fans'
// (D6D, the class fan-look, #334)

import 'src/css/tokens/type.css';
import 'src/css/tokens/atlas.css';
import 'src/css/tokens/fan.css';
import 'src/css/tokens/stamp-album.css';
import 'src/css/tokens/app-loader.css'; // the shared parts' global styles (the scroll fade, #219)

import 'src/css/ui/scroll-fade.css';
import 'src/css/ui/look-page.css'; // the choices the old demo picker on /home made (removed with it in #339), fixed at what test and production showed:
// the participation strip's style and its depth (Header.vue) and the heads between the lists in the wizard's results
// ("UNESCO-biosfeerreservaten 797", #126; findSearch.js). They go with glass, the last of the old theme code (#333)

var DEMO = Object.freeze({
  notice: 'boldfull',
  depth: 'soft',
  listHeads: 'on'
});
export default (function () {
  // glass on every server: the dev-only themes (modern-light, modern-dark, neon) and their picker went in #333
  document.documentElement.setAttribute('data-theme', 'glass');
  Vue.prototype.$theme = {
    demo: DEMO
  };
});